<template>
  <article class="square-unit-item" :class="`unit-item-${index}`">
    <header class="unit-header">
      <div class="d-flex align-center">
        <v-avatar min-width="40" width="40" height="40">
          <v-img :src="getProfileImage" />
        </v-avatar>
        <dl class="unit-header-info">
          <dt class="name">{{ item.regNm }}</dt>
          <dd class="date">{{ item.regDt | yyyyMMdd }}</dd>
          <dd class="mission" v-if="item.freeYn === 'N'">{{ item.ndayMission }}일차 미션</dd>
        </dl>
      </div>
      <v-btn icon plain :ripple="false"
             class="btn-sheet-menu"
             @click="$emit('onEvent', {fn: 'menuModalOpen', item: item, index: index, gubun: 'regi' })"></v-btn>
    </header>

    <div class="unit-body">
      <div class="unit-text" :class="{ 'more' : item.more && item.more !== undefined }">
        <div class="text-pre-wrap ">
          {{ item.content }}
          <v-btn text plain :ripple="false"
                 class="btn-cmt-more"
                 @click="$emit('onEvent', {fn: 'readMore', item: item, index: index})"
          >{{ (item.more && item.more !== undefined) ? '접기' : '더보기' }}</v-btn>
        </div>
      </div>
    </div>

    <div :class="[`square-unit-info ${item.regUserKey !== userKey ? 'remove-router' : ''}`]"
         @click="$emit('onEvent', {fn: 'unitDetails', item: item, index: index })">
      <div class="tit">{{ item.unitTitle }}</div>
      <div class="txt">
        {{ item.duraTime | duraTimeSec }} | {{ item.helpfulCdNm }}
      </div>
    </div>

    <footer class="unit-footer">
      <v-btn text plain :ripple="false"
             class="btn-comment"
             @click="$emit('onEvent', {fn: 'goCmntList', item: item, index: index })"
      ><i></i>{{ item.cmntCnt }}</v-btn>
      <v-btn text plain :ripple="false"
             class="btn-like"
             :class="{ 'active' : item.isPraise === 'Y' }"
             @click="$emit('onEvent', {fn: 'likeClick', item: item, index: index })"
      ><i></i>{{ item.praiseCnt }}</v-btn>
    </footer>
  </article>
</template>

<script>
import { mixinAuth, mixinRemote } from '@/mixins'
export default {
  name: 'SquareItem',
  mixins: [ mixinAuth, mixinRemote ],
  props: {
    index: Number,
    item: Object
  },
  computed: {
    getProfileImage () {
      let profileAtchNo = this.item.profileAtchNo
      let profileAtchFileName = this.item.profileAtchFileName
      let clientNo = this.item.clientNo

      let avatar = null
      if(profileAtchNo == null || profileAtchNo < 1){
        if(this.isSamsungFire){
          avatar = this.avatarImages.filter(a => a.key === profileAtchNo)
          if (avatar.length) return avatar[0].url
          else return this.avatarImages[0].url

        } else{
          return require('@/assets/images/bi/bi_img.png')
        }

      } else{

        if (clientNo === 'samsungfire') { // 삼성화재

          avatar = this.avatarImages.filter(a => a.key === profileAtchNo)
          if (avatar.length) return avatar[0].url
          else return this.avatarImages[0].url

        }else{
          avatar = profileAtchFileName
          return this.$downUrl(avatar)
        }
      }
    }
  },
  filters: {
    yyyyMMdd: function (value) {
      if (value === '') return '';
      var js_date = new Date(value);
      var year = js_date.getFullYear();
      var month = js_date.getMonth() + 1;
      var day = js_date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return year + '.' + month + '.' + day;
    },
    duraTimeSec: function (value) {
      if (value === '') return ''
      return value + ':00';
    }
  }
}
</script>
